import { WarningExclamation } from "@monsterindia/global-ui-components";

import {
  LOWER_THRESHOLD,
  UPPER_THRESHOLD,
} from "../../../constants/employment";
import { convertToNearstCrore } from "../../../helpers/convertToNearstCrore";

export const HighLowSalaryWarning = ({
  absoluteSalary,
}: {
  absoluteSalary: number;
}) => {
  if (!absoluteSalary) {
    return null;
  }

  const isLowSalary = absoluteSalary < LOWER_THRESHOLD;
  const isHighSalary = absoluteSalary > UPPER_THRESHOLD;

  const lowSalaryWarningText = (
    <p className="l1-text-xs l1-text-content-secondary l1-font-normal">
      This adds up to just{" "}
      <span className="l1-text-content-primary l1-font-semibold">
        ₹{(absoluteSalary / 12).toFixed(2)} per month
      </span>
      . Just checking — is that correct?
    </p>
  );

  const highSalaryWarningText = (
    <p className="l1-text-xs l1-text-content-secondary l1-font-normal">
      You’ve entered{" "}
      <span className="l1-text-content-primary l1-font-semibold">
        ₹{convertToNearstCrore(absoluteSalary)} cr
      </span>
      . Please double-check for accuracy — could there be an extra digit?
    </p>
  );

  return (
    <div
      className={`l1-flex l1-items-center l1-justify-center l1-gap-4 l1-bg-state-surface-warning-subtle l1-rounded-lg l1-p-3 ${!isLowSalary && !isHighSalary ? "l1-invisible" : ""}`}
    >
      <WarningExclamation
        className={"l1-min-w-[30px] salary-waring-icon"}
        width={30}
        height={30}
      />
      {isLowSalary ? lowSalaryWarningText : highSalaryWarningText}
    </div>
  );
};
